import React from 'react'
import PropTypes from 'prop-types'

const baseOffset = 24

const BaseSkeleton = ({ w, h, radius, color }) => {
  const skeletonFixed = `
    @keyframes skeletonFixed {
      0%   { background-position: -${w}px; }
      40%  { background-position: ${w}px; }
      100% { background-position: ${w + 100}px; }
    }
  `

  const skeleton = `
    @keyframes skeleton {
      0%   { background-position: -100px; }
      40%  { background-position: 200px; }
      100% { background-position: 1000px; }
    }
  `

  // Extract width unit logic
  let widthUnit = ''
  if (w) {
    const wStr = w.toString()
    if (wStr.indexOf('px') === -1 && wStr.indexOf('%') === -1) {
      widthUnit = 'px'
    }
  }

  // Extract height unit logic
  let heightUnit = ''
  if (h) {
    const hStr = h.toString()
    if (hStr.indexOf('px') === -1 && hStr.indexOf('%') === -1) {
      heightUnit = 'px'
    }
  }

  return (
    <>
      <style>
        {w && w.toString().indexOf('%') !== -1 ? skeleton : skeletonFixed}
      </style>
      <div
        style={{
          width: w ? `${w}${widthUnit}` : `${baseOffset}px`,
          height: h ? `${h}${heightUnit}` : `${baseOffset}px`,
          backgroundColor: '#ccc',
          borderRadius: radius || `0%`,
          backgroundImage: `linearGradient(
            90deg,
            ${color || '#e0e0e0'} 0px,
            ${color || '#e0e0e0'} 40px,
            ${color || '#e0e0e0'} 80px
          )`,
          animation: `${
            w && w.toString().indexOf('%') !== -1 ? 'skeleton' : 'skeletonFixed'
          } 12s infinite linear`
        }}
      />
    </>
  )
}

BaseSkeleton.propTypes = {
  color: PropTypes.string,
  radius: PropTypes.number,
  w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  h: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default BaseSkeleton
